// Sichtbarkeit je Mitarbeiter (Rolle „team“): vierstufige Rechnungs-Sichtbarkeit, abgeleitet aus
// profiles.sieht_alle_rechnungen + profiles.rechnungen_bereich. Unverändert aus SichtbarkeitTab herausgelöst.

export type RechnungsStufe = 'alle' | 'weg' | 'mv' | 'eigene';

export interface RechnungsFelder { sieht_alle_rechnungen: boolean; rechnungen_bereich: string | null }

export const STUFEN_WERTE: Record<RechnungsStufe, RechnungsFelder> = {
  alle: { sieht_alle_rechnungen: true, rechnungen_bereich: 'alle' },
  weg: { sieht_alle_rechnungen: true, rechnungen_bereich: 'weg' },
  mv: { sieht_alle_rechnungen: true, rechnungen_bereich: 'mv' },
  eigene: { sieht_alle_rechnungen: false, rechnungen_bereich: null },
};

export const STUFEN_LABEL: Record<RechnungsStufe, string> = {
  alle: 'Alle',
  weg: 'WEG',
  mv: 'MV',
  eigene: 'Nur eigene',
};

export const STUFEN: readonly RechnungsStufe[] = ['alle', 'weg', 'mv', 'eigene'];

export const stufeAus = (p: RechnungsFelder): RechnungsStufe =>
  !p.sieht_alle_rechnungen ? 'eigene'
  : p.rechnungen_bereich === 'weg' ? 'weg'
  : p.rechnungen_bereich === 'mv' ? 'mv'
  : 'alle';
